var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-list-column',{staticClass:"column",attrs:{"format":{}}},[_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"actions-check-box",class:{'is-active': _vm.isSelected},on:{"click":_vm.onSelectToggle}},[(_vm.isSelected)?_c('i',{staticClass:"fa fa-check"}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }